import "./FooterContent.scss";
import PropTypes from "prop-types";
import {
  CtaLinks,
  TextItems,
} from "components/GecoComponentRouter/FooterContent";
import { GSAPAnimation } from "components/GSAP";

export const FooterContent = ({ component, lang }) => {
  const {
    backgroundImage,
    backgroundColor,
    isFullScreen,
    title,
    marginBottom,
    isFullHeight,
    cta,
    text,
  } = component.fields;

  const containerClass = `${marginBottom.staticValue[0]} ${
    isFullHeight.staticValue ? "footer-content--full-height" : ""
  }`.trim();

  const subContainerClass = !isFullScreen.staticValue
    ? "globalComponentContainer"
    : "";
  const uppercaseClass = backgroundImage.staticValue.id
    ? "footer-content--title--uppercase"
    : "";
  const backgroundStyle = backgroundImage.staticValue.id
    ? {
        backgroundColor: "#000",
        backgroundImage: `linear-gradient(
          rgba(0, 0, 0, 0.25),
          rgba(0, 0, 0, 0.25)
        ), url(${backgroundImage.staticValue.url})`, // background image with overlay
      }
    : { backgroundColor: backgroundColor.staticValue };

  const mixBlendModeStyle = !backgroundImage.staticValue.id
    ? {
        color: backgroundColor.staticValue === "#000" ? "#fff" : "#000",
        mixBlendMode:
          backgroundColor.staticValue === "#000" ? "difference" : "normal",
      }
    : {};

  return (
    <div
      className={`geco-footer-content ${containerClass}`}
      style={backgroundStyle}
    >
      <div className={subContainerClass}>
        <div className="footer-content--main-box">
          <div className="footer-content--box">
            <GSAPAnimation onScreenAnimation="fadeUp">
              <p
                className={`title-high footer-content--title ${uppercaseClass}`}
                dangerouslySetInnerHTML={{ __html: title.staticValue }}
                style={mixBlendModeStyle}
              />
            </GSAPAnimation>
            <GSAPAnimation onScreenAnimation="fadeUp">
              {cta?.length > 0 && (
                <CtaLinks cta={cta} style={mixBlendModeStyle} />
              )}
              {text?.staticValue?.length > 0 && (
                <TextItems text={text} style={mixBlendModeStyle} />
              )}
            </GSAPAnimation>
          </div>
        </div>
      </div>
    </div>
  );
};

FooterContent.propTypes = {
  lang: PropTypes.string,
  component: PropTypes.shape({
    id: PropTypes.string,
    controlId: PropTypes.arrayOf(PropTypes.string),
    type: PropTypes.string,
    fields: PropTypes.shape({
      backgroundImage: PropTypes.shape({
        staticValue: PropTypes.shape({
          id: PropTypes.string,
          url: PropTypes.string,
          name: PropTypes.string,
          width: PropTypes.number,
          height: PropTypes.number,
          isDark: PropTypes.bool,
          fileExtension: PropTypes.string,
        }),
      }),
      backgroundColor: PropTypes.shape({
        staticValue: PropTypes.string,
      }),
      isFullScreen: PropTypes.shape({
        staticValue: PropTypes.bool,
      }),
      title: PropTypes.shape({
        staticValue: PropTypes.string,
      }),
      marginBottom: PropTypes.shape({
        staticValue: PropTypes.arrayOf(
          PropTypes.oneOf([
            "margin__bottom__0",
            "margin__bottom__80",
            "margin__bottom__160",
            "margin__bottom__240",
          ])
        ).isRequired,
      }),
      isFullHeight: PropTypes.shape({
        staticValue: PropTypes.bool,
      }),
      cta: PropTypes.arrayOf(
        PropTypes.shape({
          text: PropTypes.shape({
            staticValue: PropTypes.string,
          }),
          link: PropTypes.shape({
            staticValue: PropTypes.string,
          }),
          newTab: PropTypes.shape({
            staticValue: PropTypes.bool,
          }),
        })
      ),
      text: PropTypes.shape({
        staticValue: PropTypes.arrayOf(PropTypes.string),
      }),
    }),
  }),
};
